// Helpers compartilhados entre as abas do Relatório de Produtividade.

export const POSITIVE_COLOR = '#43a047';
export const NEGATIVE_COLOR = '#ef5350';
export const MUTED_COLOR = '#aaa';
export const NEUTRAL_BAR = '#0288d1';
export const FREELANCE_COLOR = '#7b1fa2';

// KPIs em que diminuir é bom (delta negativo deve aparecer verde).
export const INVERT_DELTA_COLOR = new Set([
   'notRealized',
   'pending',
   'notRealizedAM',
   'notRealizedPM',
   'totalNotRealizedValue',
]);

export function formatCurrency(value) {
   return Number(value || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
   });
}

export function formatNumber(value) {
   return Number(value || 0).toLocaleString('pt-BR');
}

export function formatPercent(value, decimals = 1) {
   if (value === null || value === undefined) return '—';
   return `${Number(value).toFixed(decimals).replace('.', ',')}%`;
}

export function formatDayLong(yyyymmdd) {
   if (!yyyymmdd) return '—';
   const [y, m, d] = String(yyyymmdd).split('-');
   if (!m || !d) return '—';
   return `${d}/${m}/${y}`;
}

export function formatDayShort(yyyymmdd) {
   if (!yyyymmdd) return '';
   const [, m, d] = String(yyyymmdd).split('-');
   if (!m || !d) return '';
   return `${d}/${m}`;
}

// Período padrão: mês corrente (dia 1 até hoje).
export function getCurrentMonthRange() {
   const now = new Date();
   const yyyy = now.getFullYear();
   const mm = String(now.getMonth() + 1).padStart(2, '0');
   const dd = String(now.getDate()).padStart(2, '0');
   return {
      dateFrom: `${yyyy}-${mm}-01`,
      dateTo: `${yyyy}-${mm}-${dd}`,
   };
}

export function isValidIsoDate(value) {
   return /^\d{4}-\d{2}-\d{2}$/.test(value || '');
}

// Calcula cor e texto do badge de delta.
//   value: número ou null
//   options.absolute: true → exibe +N / -N (sem %)
//   options.invert:   true → negativo verde, positivo vermelho
export function buildDelta(value, { absolute = false, invert = false } = {}) {
   if (value === null || value === undefined) {
      return { text: '—', color: MUTED_COLOR, hasValue: false };
   }
   const isPositive = value > 0;
   const isZero = value === 0;
   // eslint-disable-next-line no-nested-ternary
   const arrow = isZero ? '' : isPositive ? '▲' : '▼';
   const magnitude = absolute
      ? Math.abs(value).toString()
      : `${Math.abs(value).toFixed(1).replace('.', ',')}%`;
   // eslint-disable-next-line no-nested-ternary
   const sign = isZero ? '' : isPositive ? '+' : '−';
   const text = isZero ? '0' : `${arrow} ${sign}${magnitude}`;

   let color = MUTED_COLOR;
   if (!isZero) {
      const goodDirectionUp = !invert;
      const isGood = goodDirectionUp ? isPositive : !isPositive;
      color = isGood ? POSITIVE_COLOR : NEGATIVE_COLOR;
   }

   return { text, color, hasValue: true };
}
